<div class="alarms-summary">
  <div *ngIf="journal" class="arm-summary">

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Date & Time:</span>
      <span class="arm-summary-value" fxFlex>{{journal.createDate | date : 'dd-MMM-yy H:mm:ss'}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Source:</span>
      <span class="arm-summary-value" fxFlex>{{journal.source}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Name:</span>
      <span class="arm-summary-value" fxFlex>{{journal.actionDescription}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Operator:</span>
      <span class="arm-summary-value" fxFlex>{{journal.operator}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Description:</span>
      <span class="arm-summary-value" fxFlex>{{journal.description}}</span>
    </div>

    <div class="journal-details-tree" *ngIf="journal.value !== 'null'">
      <info-tree [json]="jsonObject"></info-tree>
    </div>

  </div>
</div>
